import { useParams } from 'react-router-dom';

import { useForm, useNavigation } from '@refinedev/core';

import { useSnackbar } from '@rrexpress/core';

import { BaseEdit } from '@/components/edit';
import useContact from '@/modules/contact/application/contact';
import { IContact } from '@/modules/contact/model/contact';

import ContactForm from './form';

const ContactUpdate = () => {
  const { list } = useNavigation();
  const { show } = useSnackbar();
  const { id } = useParams<{ id: string }>();
  const { updateContact, loadingUpdate } = useContact();
  const { queryResult } = useForm();
  const data = (queryResult?.isSuccess ? queryResult?.data?.data : null) as IContact;

  async function handleOnSubmit(val: any) {
    try {
      await updateContact(id as string, val);
      list('contacts');
      show('Berhasil mengubah kontak', 'success');
    } catch (error) {
      show('Gagal mengubah kontak', 'error');
    }
  }
  return (
    <div className="w-[50vw] flex m-auto justify-center">
      <BaseEdit
        title="Ubah Kontak"
        isLoading={loadingUpdate || !queryResult?.isSuccess}
      >
        {data && (
          <ContactForm
            onFinish={handleOnSubmit}
            type="update"
            initialValue={data}
          />
        )}
      </BaseEdit>
    </div>
  );
};

export default ContactUpdate;
